import React from 'react';


const certifications = [
  { 
    id: '01', 
    name: 'ISO/IEC 27001:2022', 
    provider: 'Information Security Management', 
    status: 'VERIFIED',
    logo: '/27000.png'
  },
  { 
    id: '02', 
    name: 'ISO/IEC 20000-1:2018', 
    provider: 'IT Service Management System', 
    status: 'VERIFIED',
    logo: '/20000.png'
  }
];

export default function CertGrid() {
  return (
    <section className="py-24 px-6 relative">

          <div className="max-w-7xl mx-auto">

            <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">

              <div className="space-y-4">

                <h3 className="text-4xl md:text-5xl font-black tracking-tighter text-white uppercase">

                  Global Trust <br /> <span className="text-blue-300">Certifications</span>

                </h3>

              </div>

              <p className="max-w-md text-slate-400 font-serif italic text-right">

                SecuWall maintains the highest industry standards to ensure your data remains under

                unrivaled protection protocols.

              </p>

            </div>

    {/* Centered Grid Container */}
        <div className="flex justify-center w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 w-full max-w-4xl">
            {certifications.map((cert) => (
              <div 
                key={cert.id}
                className="group relative p-10 bg-slate-900/40 border border-white/10 hover:border-green-500/50 transition-all duration-500 overflow-hidden backdrop-blur-md"
              >
                {/* Background ID Number */}
                <span className="absolute -right-2 -bottom-4 text-8xl font-black text-white/[0.03] italic transition-colors">
                  {cert.id}
                </span>

                <div className="relative z-10 flex flex-col items-center text-center space-y-6">
                  {/* Centered Logo Container - No Glow/Grayscale */}
                  <div className="w-32 h-32 flex items-center justify-center">
                    <img 
                      src={cert.logo} 
                      alt={cert.name} 
                      className="max-w-full max-h-full object-contain"
                    />
                  </div>
                  
                  <div className="w-full">
                    <h4 className="text-2xl font-bold text-white tracking-tight">{cert.name}</h4>
                    <p className="text-xs text-slate-500 font-mono mt-2 uppercase tracking-widest">
                      {cert.provider}
                    </p>
                  </div>

                  <div className="w-full pt-6 border-t border-white/5 flex justify-between items-center">
                    <div className="flex items-center gap-2">
                      <div className="w-1.5 h-1.5 bg-green-500 rounded-full shadow-[0_0_5px_#22c55e]" />
                      <span className="text-[10px] font-mono tracking-[0.2em] text-green-500/80 uppercase">Verified_Node</span>
                    </div>
                    <span className="text-[10px] font-mono font-bold text-white bg-green-500/20 px-3 py-1 rounded">
                      {cert.status}
                    </span>
                  </div>
                </div>

                {/* Subtle Hover Scanline */}
                <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-green-400/50 to-transparent -translate-x-full group-hover:animate-[scan_3s_linear_infinite]" />
              </div>
            ))}
          </div>
        </div>
      </div>
    
      <style jsx>{`
        @keyframes scan {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </section>
  );
}